import { Toast  } from 'mint-ui';
function toast (message) {
        Toast({
            message: message,
            position: 'bottom',
            duration: 2000
          });        
}
export default toast


// WEBPACK FOOTER //
// ./src/utils/toast.js